import React from "react";
import { Redirect } from "react-router-dom";

//Dashboard
import DashboardAnalytics from "../pages/DashboardAnalytics";
import Tenants from "../pages/TenantsManagement/Tenants";
import Users from "../pages/Users";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import LogoutSuccess from "../pages/Authentication/LogoutSuccess";
import SignUp from "../pages/Authentication/SignUp";
import ActivateAccount from "../pages/Authentication/ActivateAccount";

// error pages
import GeneralErrorPage from "../pages/AuthenticationInner/Errors/GeneralErrorPage";
import NotFoundPage from "../pages/AuthenticationInner/Errors/NotFoundPage";
import ForbiddenPage from "../pages/AuthenticationInner/Errors/ForbiddenPage";
import HubspotCallback from "../pages/Oauth/HubspotCallback";

// User Profile
import UserProfile from "../pages/Authentication/UserProfile";
import HubSpotIntegration from "../pages/HubspotIntegration";
import Integration from "../pages/Integration"; // New main integration page

import Account from "../pages/Account";
import Customers from "../pages/TenantsManagement/Customers/index";
import TenantDetails from "../pages/TenantDetails";
import Teams from "../pages/Teams/index";
import SmsHistory from "../pages/SmsHistory/index";
import SmsLogDetail from "../pages/SmsLogs/SmsLogDetail";
import HowToUsePage from "../pages/HowToUse";
import ResetPasswordPage from "../pages/Authentication/ResetPassword";
import ChangePasswordPage from "../pages/Authentication/ChangePassword";
import AllAccounts from "../pages/AllAccounts";
import TenantSettings from "../pages/TenantSettings";
import SystemTools from "../pages/SystemTools";
import PlanUsage from "../pages/PlanUsage";

//Layouts
import VerticalLayout from "../layouts/index";
import NonAuthLayout from "../layouts/NonAuthLayout";

const authProtectedRoutes = [
  {
    path: "/dashboard",
    component: DashboardAnalytics,
    layout: VerticalLayout,
  },
  {
    path: "/usage",
    exact: true,
    component: () => <Redirect to="/tenants" />,
    layout: VerticalLayout,
  },
  {
    path: "/plan-usage",
    component: PlanUsage,
    layout: VerticalLayout,
  },
  {
    path: "/tenants/:id",
    component: TenantDetails,
    layout: VerticalLayout,
    exact: true,
  },
  {
    path: "/tenants",
    component: Tenants,
    layout: VerticalLayout,
    exact: true,
  },
  {
    path: "/onboarding",
    exact: true,
    component: () => <Redirect to="/tenants" />,
    layout: VerticalLayout,
  },
  {
    path: "/users",
    component: Users,
    layout: VerticalLayout,
  },
  {
    path: "/all-accounts",
    component: AllAccounts,
    layout: VerticalLayout,
  },

  {
    path: "/integration",
    component: Integration,
    layout: VerticalLayout,
  },
  {
    path: "/hubspot",
    component: HubSpotIntegration,
    layout: VerticalLayout,
  },

  //User Profile
  { path: "/profile", component: UserProfile, layout: VerticalLayout },

  { path: "/customers", component: Customers, layout: VerticalLayout },
  {
    path: "/sms-logs/:id",
    component: SmsLogDetail,
    layout: VerticalLayout,
    exact: true,
  },
  {
    path: "/sms-logs",
    component: SmsHistory,
    layout: VerticalLayout,
    exact: true,
  },
  { path: "/team", component: Teams, layout: VerticalLayout },
  { path: "/account", component: Account, layout: VerticalLayout },
  {
    path: "/tenant-settings",
    component: TenantSettings,
    layout: VerticalLayout,
  },
  {
    path: "/how-to-use",
    component: HowToUsePage,
    layout: VerticalLayout,
  },
  {
    path: "/system-tools",
    component: SystemTools,
    layout: VerticalLayout,
  },

  // For changing password where user is already login
  {
    path: "/change-password",
    component: ChangePasswordPage,
    layout: NonAuthLayout,
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    layout: VerticalLayout,
  },

  { path: "*", component: NotFoundPage, layout: NonAuthLayout },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout-success", component: LogoutSuccess },
  { path: "/oauth-callback", component: HubspotCallback },
  // Login - unified endpoint for all users
  { path: "/login", component: Login },

  { path: "/forgot-password", component: ForgetPasswordPage },
  { path: "/reset-password/:token", component: ResetPasswordPage },
  { path: "/reset-password", component: () => <Redirect to="/403" /> },

  // For admin/user activation (invitation flow)
  { path: "/activate/:token", component: ActivateAccount },
  { path: "/activate", component: () => <Redirect to="/403" /> },

  // For client route sign up
  { path: "/sign-up/:token", component: SignUp },
  { path: "/sign-up", component: () => <Redirect to="/403" /> },

  // For team member route sign up
  { path: "/register/:token", component: SignUp },
  { path: "/register", component: () => <Redirect to="/403" /> },

  { path: "/error", component: GeneralErrorPage },
  { path: "/404", component: NotFoundPage },
  { path: "/403", component: ForbiddenPage },
];

export { authProtectedRoutes, publicRoutes };
